export * from './EmptySectionAlerts'

import EmptySectionAlerts from './EmptySectionAlerts'
export default EmptySectionAlerts
